<template>
  <v-form>
    <v-container fluid>

      <v-row>
        <!-- todo : fix the dateTime format, not supported by default on vuetify -->
        <v-col cols="12" sm="6" md="6">
          <InputDate
            v-model="item.createdAt"
            :label="$t('createdAt')"
            :error-messages="createdAtErrors"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <InputDate
            v-model="item.dueAt"
            :label="$t('dueAt')"
            :error-messages="dueAtErrors"
          />
        </v-col>

      </v-row>

    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { mapActions } from 'vuex';
import InputDate from '../InputDate';
import { date } from '../../validators/date';

export default {
  name: 'CreditTransferPaymentRunForm',
  mixins: [validationMixin],
  components: {
    InputDate,
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    },
    debtor: {
      type: String,
      default: ''
    }
  },
  computed: {
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    debtorErrors() {
      const errors = [];

      if (!this.$v.item.debtor.$dirty) return errors;

      has(this.violations, 'debtor') && errors.push(this.violations.debtor);


      return errors;
    },
    creditTransfersErrors() {
      const errors = [];

      if (!this.$v.item.creditTransfers.$dirty) return errors;

      has(this.violations, 'creditTransfers') && errors.push(this.violations.creditTransfers);


      return errors;
    },
    createdAtErrors() {
      const errors = [];

      if (!this.$v.item.createdAt.$dirty) return errors;

      has(this.violations, 'createdAt') && errors.push(this.violations.createdAt);


      return errors;
    },
    processedAtErrors() {
      const errors = [];

      if (!this.$v.item.processedAt.$dirty) return errors;

      has(this.violations, 'processedAt') && errors.push(this.violations.processedAt);


      return errors;
    },
    dueAtErrors() {
      const errors = [];

      if (!this.$v.item.dueAt.$dirty) return errors;

      has(this.violations, 'dueAt') && errors.push(this.violations.dueAt);


      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        debtorGetSelectItems: 'party/fetchSelectItems'
      }),
      ...mapActions({
        creditTransfersGetSelectItems: 'credittransfer/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      debtor: {
      },
      creditTransfers: {
      },
      createdAt: {
        date,
      },
      processedAt: {
        date,
      },
      dueAt: {
        date,
      },
    }
  }
};
</script>
